import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

import { Swiper, SwiperSlide } from 'swiper/vue'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('Swiper', Swiper)
  app.component('SwiperSlide', SwiperSlide)
}
